import { LashistaState } from './state';

export const lashistaInitialState: LashistaState = {
  listLashista: [],
  currentLashista: undefined,
};
